import { IOrderLine } from './order-line.interface';

export interface IExtendedOrderLine extends IOrderLine {
    salesOrderLine: number;
    pgiDate?: string;
    shipToCustomerNumber: string;
    shipToCustomerName: string;
    shipToCountryCode: string;
    transportUnit?: string;
    deliveredQuantity: number;
    deliveryNumber?: string;
    shipmentNumber?: string;
    carrierTrackingNumber?: string;
    soCreationDate: string;
    soldToCustomerName?: string;
}
